/* Bean Shipper · Bundles collection (sections/collection__bs-bundles.liquid), 25 Sep 2026.
   Box-size tabs, mood chips, sort (featured, biggest saving, price, A-Z), live counts, reveal on
   scroll and quick-add feedback. Filter state rides in the URL (?size= &mood= &order=) so a
   filtered view can be shared. Adding to the bag is the theme's job: bean-shipper.js listens for
   [data-bs-quick-add] clicks; this file only mirrors the result on the button, read from the toast
   that script shows. Without this file every card still renders, links and adds. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bsbx]');
  if (!root || root.getAttribute('data-bsbx-ready')) return;
  root.setAttribute('data-bsbx-ready', '1');

  function all(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }

  var grid = root.querySelector('[data-bsbx-grid]');
  var cells = grid ? all('[data-bsbx-card]', grid) : [];
  var tabs = all('[data-bsbx-size]');
  var moodChips = all('[data-bsbx-mood]');
  var clearBtns = all('[data-bsbx-clear]');
  var chipClear = root.querySelector('.bsbx__clear');
  var sortSels = all('[data-bsbx-sort]');
  var countEl = root.querySelector('[data-bsbx-count]');
  var emptyEl = root.querySelector('[data-bsbx-empty]');
  var tools = root.querySelector('.bsbx__tools');
  var bar = root.querySelector('[data-bsbx-bar]');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var SIZES = { all: 1, '2': 1, '3': 1, big: 1 };
  var MOODS = {};
  moodChips.forEach(function (c) { MOODS[c.getAttribute('data-bsbx-mood')] = 1; });
  var SORTS = { featured: 1, saving: 1, low: 1, high: 1, az: 1 };
  var state = { size: 'all', mood: '', sort: 'featured' };

  try {
    var q = new URLSearchParams(window.location.search);
    if (SIZES[q.get('size')]) state.size = q.get('size');
    if (MOODS[q.get('mood')]) state.mood = q.get('mood');
    if (SORTS[q.get('order')]) state.sort = q.get('order');
  } catch (e) {}

  function sizeOk(cell, size) { return size === 'all' || cell.getAttribute('data-size') === size; }
  function moodOk(cell) { return !state.mood || (cell.getAttribute('data-moods') || '').indexOf(' ' + state.mood + ' ') !== -1; }
  function num(cell, attr) { return parseFloat(cell.getAttribute(attr)) || 0; }
  function byPos(a, b) { return num(a, 'data-pos') - num(b, 'data-pos'); }
  var sorters = {
    featured: byPos,
    saving: function (a, b) { return (num(b, 'data-save') - num(a, 'data-save')) || byPos(a, b); },
    low: function (a, b) { return (num(a, 'data-price') - num(b, 'data-price')) || byPos(a, b); },
    high: function (a, b) { return (num(b, 'data-price') - num(a, 'data-price')) || byPos(a, b); },
    az: function (a, b) { return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || ''); }
  };

  var io = null;
  function columns() {
    if (!grid) return 1;
    var t = (window.getComputedStyle(grid).gridTemplateColumns || '').split(' ');
    var n = 0;
    for (var i = 0; i !== t.length; i++) { if (t[i] && t[i] !== '0px') n++; }
    return n || 1;
  }
  function reveal(visible) {
    if (reduce || !('IntersectionObserver' in window)) {
      visible.forEach(function (c) { c.classList.add('is-in'); });
      return;
    }
    if (io) io.disconnect();
    var cols = columns();
    visible.forEach(function (c, i) {
      c.classList.remove('is-in');
      c.style.setProperty('--d', ((i % cols) * 80) + 'ms');
    });
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    visible.forEach(function (c) { io.observe(c); });
  }

  function writeUrl() {
    try {
      var u = new URL(window.location.href);
      var put = function (k, v, dflt) { if (v && v !== dflt) u.searchParams.set(k, v); else u.searchParams.delete(k); };
      put('size', state.size, 'all');
      put('mood', state.mood, '');
      put('order', state.sort, 'featured');
      window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  function keepInView() {
    if (!tools || !bar) return;
    var barBottom = bar.getBoundingClientRect().bottom;
    var top = tools.getBoundingClientRect().top;
    if (top >= barBottom) return;
    var y = window.pageYOffset + top - barBottom - 12;
    try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y); }
  }

  function press(el, on) {
    el.classList.toggle('is-on', on);
    el.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function apply(initial) {
    var visible = [];
    cells.forEach(function (c) {
      var ok = sizeOk(c, state.size) && moodOk(c);
      c.hidden = !ok;
      if (ok) visible.push(c);
    });
    var order = sorters[state.sort] || byPos;
    if (grid) {
      var frag = document.createDocumentFragment();
      cells.slice().sort(order).forEach(function (c) { frag.appendChild(c); });
      grid.appendChild(frag);
      grid.hidden = visible.length === 0;
    }
    visible.sort(order);

    tabs.forEach(function (tab) {
      var s = tab.getAttribute('data-bsbx-size');
      var n = 0;
      cells.forEach(function (c) { if (sizeOk(c, s) && moodOk(c)) n++; });
      var el = tab.querySelector('[data-bsbx-n]');
      if (el) el.textContent = String(n);
      press(tab, s === state.size);
    });
    moodChips.forEach(function (c) { press(c, c.getAttribute('data-bsbx-mood') === state.mood); });

    if (chipClear) chipClear.hidden = !(state.size !== 'all' || state.mood);
    if (countEl) countEl.textContent = visible.length + (visible.length === 1 ? ' box' : ' boxes');
    if (emptyEl) emptyEl.hidden = visible.length !== 0;
    sortSels.forEach(function (sel) { if (sel.value !== state.sort) sel.value = state.sort; });

    reveal(visible);
    if (!initial) { writeUrl(); keepInView(); }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () { state.size = tab.getAttribute('data-bsbx-size'); apply(false); });
  });
  moodChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var m = chip.getAttribute('data-bsbx-mood');
      state.mood = state.mood === m ? '' : m;
      apply(false);
    });
  });
  clearBtns.forEach(function (b) {
    b.addEventListener('click', function () { state.size = 'all'; state.mood = ''; apply(false); });
  });
  sortSels.forEach(function (sel) {
    sel.addEventListener('change', function () { state.sort = SORTS[sel.value] ? sel.value : 'featured'; apply(false); });
  });

  /* The theme header is position:fixed. Park the filter bar right under whatever part of it is on
     screen, so it never tucks behind the header or floats below a header that has moved away. */
  var header = document.querySelector('header.nav') || document.querySelector('[data-bs-header]');
  var lastTop = -1;
  var ticking = false;
  function syncTop() {
    ticking = false;
    if (!header) return;
    var b = Math.round(header.getBoundingClientRect().bottom);
    if (b > 0 && b <= 200) { if (b !== lastTop) { lastTop = b; root.style.setProperty('--top', b + 'px'); } }
    else if (lastTop !== 0) { lastTop = 0; root.style.setProperty('--top', '0px'); }
  }
  function queue() { if (!ticking) { ticking = true; window.requestAnimationFrame(syncTop); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  syncTop();

  /* Quick-add feedback: bean-shipper.js posts to /cart/add.js, opens the drawer and shows a
     .bs-toast; its is-error class marks a failed add. */
  function setLabel(btn, longText, shortText) {
    var l = btn.querySelector('[data-bsbx-qa-l]');
    var s = btn.querySelector('.bsbx-card__qa-s');
    if (l) l.textContent = longText;
    if (s) s.textContent = shortText;
  }
  function watchToast(done) {
    if (!('MutationObserver' in window)) { done(null); return; }
    var finished = false;
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (finished || !n.classList || !n.classList.contains('bs-toast')) return;
          finished = true;
          mo.disconnect();
          done(!n.classList.contains('is-error'));
        });
      });
    });
    mo.observe(document.body, { childList: true });
    window.setTimeout(function () { if (!finished) { finished = true; mo.disconnect(); done(null); } }, 6000);
  }
  root.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bsbx-qa]') : null;
    if (!btn || btn.classList.contains('is-busy')) return;
    if (!btn._bsbxText) {
      var l = btn.querySelector('[data-bsbx-qa-l]');
      var s = btn.querySelector('.bsbx-card__qa-s');
      btn._bsbxText = [l ? l.textContent : '', s ? s.textContent : ''];
    }
    var orig = btn._bsbxText;
    btn.classList.remove('is-added');
    btn.classList.add('is-busy');
    setLabel(btn, 'Adding…', 'Adding…');
    watchToast(function (ok) {
      btn.classList.remove('is-busy');
      if (ok) {
        btn.classList.add('is-added');
        setLabel(btn, 'Added to bag', 'Added');
        window.setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, orig[0], orig[1]); }, 1600);
      } else {
        setLabel(btn, orig[0], orig[1]);
      }
    });
  });

  root.classList.add('bsbx--js');
  apply(true);
  window.setTimeout(function () {
    var vh = window.innerHeight;
    cells.forEach(function (c) {
      if (c.hidden || c.classList.contains('is-in')) return;
      var r = c.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) c.classList.add('is-in');
    });
  }, 1500);
})();
